<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link } from "svelte-routing";
  
  export let block;
</script>

<div class="album py-5 bg-light">
  <div class="container">
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">

      {#each blocklist(block, 'gallery') as item}
      <div class="col">
        <div class="card shadow-sm">
          <img class="card-img-top" src="{image(item, 'picture', [400, 400])}">
          <div class="card-body">
            <p class="card-text">
              {text(item, 'description')}
            </p>
            <div class="d-flex justify-content-between align-items-center">
              <div class="btn-group">
              </div>
              <small class="text-muted">9 mins</small>
            </div>
          </div>
        </div>
      </div>
      {/each}

    </div>
  </div>
</div>

<style>
  .bd-placeholder-img {
      font-size: 1.125rem;
      text-anchor: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
  }

  @media (min-width: 768px) {
      .bd-placeholder-img-lg {
          font-size: 3.5rem;
      }
  }
</style>
